import React from 'react';
import {GatsbyImage, getImage} from 'gatsby-plugin-image';

const Image = ({ image }) => (
  <section className="image">
    <div className="image__inner">
      <GatsbyImage image={getImage(image?.localFile)} alt={image?.altText}/>
    </div>
  </section>
);

Image.defaultProps = {
  image: null,
};

export default Image;